const recentlyViewedMerchandiseIds: Array<string> = [
  'd7fc025a-fd93-51c0-91d8-c406a26db392',
  '05f306f3-ac63-5e65-bf80-3e6363d869fd',
  '63c42f4a-9547-56e7-933c-b3635c614d8d',
  '8fba1fdb-4fd6-561c-8058-da93584ff0d9',
]

function getRecentlyViewedMerchandise(): Promise<Array<string>> {
  return Promise.resolve(recentlyViewedMerchandiseIds)
}

export default getRecentlyViewedMerchandise
